import { merge, Stack, Text } from '@fluentui/react';
import { Player } from '@lottiefiles/react-lottie-player';
import React, { useCallback, useMemo, useRef } from 'react';
import { ResponsiveSize, useResponsiveSize } from '../contexts/responsiveContext';

const Category = (props) => {

    const {
        customStyles = {},
        active = false,
        badgeLabel = undefined,
        label = "Label",
        onClick = event => console.log(event),
        json = "",
    } = props;

    const { responsiveSize } = useResponsiveSize();
    const playerRef = useRef();

    const styles = useMemo(
        () => {
            let styles = {
                badge: {
                    root: {
                        alignItems: "end",
                        background: "red",
                        borderRadius: 3,
                        color: "white",
                        display: "flex",
                        fontSize: 15,
                        fontWeight: 700,
                        height: 15,
                        justifyContent: "center",
                        lineHeight: "11px",
                        position: "absolute",
                        right: 5,
                        top: 5,
                        width: 15
                    }
                },
                image: { height: 46 },
                label: {
                    root: {
                        color: "black",
                        fontSize: 12,
                        lineHeight: "12px",
                        textAlign: "center",
                    }
                },
                outer: {
                    root: {
                        position: "relative",
                        alignItems: "center",
                        background: "white",
                        borderRadius: 8,
                        height: 82,
                        justifyContent: "space-around",
                        opacity: active ? 1 : 0.7,
                        padding: "8px unset",
                        width: 88,
                        selectors: {
                            "&:hover": {
                                cursor: "pointer",
                                opacity: 1,
                            }
                        }
                    }
                }
            };

            if (responsiveSize >= ResponsiveSize.medium)
                styles = merge(
                    styles,
                    {
                        badge: {
                            root: {
                                top: 10,
                                right: 10,
                            }
                        },
                        image: { height: 60 },
                        label: {
                            root: {
                                fontSize: 16,
                                lineHeight: "15px",
                            }
                        },
                        outer: {
                            root: {
                                height: 125,
                                padding: "14px unset",
                                width: 135,
                            }
                        }
                    }
                );

            merge(styles, customStyles);

            return styles;
        },
        [active, customStyles, responsiveSize]
    );

    const onMouseEnter = useCallback(() => playerRef.current?.play(), []);
    const onMouseLeave = useCallback(() => playerRef.current?.stop(), []);

    return <Stack onClick={onClick} styles={styles.outer} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
        {!!badgeLabel && <Text styles={styles.badge}>{badgeLabel}</Text>}
        <Player ref={playerRef} src={json} style={styles.image} />
        <Text styles={styles.label}>{label}</Text>
    </Stack>;

};

export default Category;